import React, { useState, useEffect } from 'react';
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
import Ballot from './components/Ballot';
import MockUser from './components/MockUser';
import Confirm from './components/Confirm';
import Record from './components/Record';
import Login from './components/Login';
import Logout from './components/Logout';
import Admin from './components/Admin';
import Statement from './components/Statement';
import ViewStatement from './components/ViewStatement';
import ViewCandidate from './components/ViewCandidate';
import Home from './components/Home';
import Vote from './components/Vote';
import Validate from './components/Validate';
import PrivateRoute from "./services/PrivateRoute"
import {
  HashRouter as Router,
  Route
} from 'react-router-dom';
import './App.css';
import ManageElection from './components/ManageElection';
import ManageCandidate from './components/ManageCandidate';
import ViewAllCandidates from './components/ViewAllCandidates';
import ManageParty from './components/ManageParty';
import ManageAdmin from './components/ManageAdmin';
import ManageResults from './components/ManageResults';
import EditElection from './components/EditElection';
import CandidateProfile from './components/CandidateProfile';
import axios from 'axios';
import authHeader from "./services/AuthHeader";
import AuthService from './services/AuthService';
import ViewAllApproved from './components/ViewAllApproved'
import registerAxiosInterceptors from './services/RegisterAxiosInterceptors';

registerAxiosInterceptors();


export default function App(props) {
  const [mock, setMock] = useState([]);
  const [votes, setVotes] = useState(
    {
      "ElectionId": "",
      "UUID": "",
      "StarId" : "",
      "allBallots": []
    }
  );
  const [electionData,setElectionData] = useState([{locked: false}]);
  const [ballotData,setBallotData] = useState([]);
  const [studentInfo, setStudentInfo] = useState([]);
  const [isLoading, ] = useState(true);
  const [rerender, setrerender] = useState(false)
  

  useEffect(() => {

    axios
      .get(
        process.env.REACT_APP_API_BASE + 'allelections/',{ headers: authHeader() }
      )
      .then((res) => {
        setElectionData(res.data);
      })
      .catch((error) => {
        console.error('Unable to load election list.', error);
      });
    }, []);

  const handlePost = () => {
    let setrerender_temp = rerender;
    setrerender(!setrerender_temp);
  }

  return (
    <>
    <Router>
      <PageHeader electionData={electionData} rerender={rerender}/>
      <div className='l-canvas container'>
        <div className='container'>
          <Route path = "/login" component = {Login}/>
          <Route path = "/logout" component = {Logout}/>
          <Route path = "/candidates" component = {ViewAllApproved}/>
          <PrivateRoute exact  path = "/validate" component = {Validate}/>
          <PrivateRoute exact path="/ballot" component = {Ballot} data = {{ mock: mock, votes:votes, setVotes:setVotes, studentInfo:studentInfo, ballotData:ballotData}}/>
            <PrivateRoute exact path="/confirm" component = {Confirm} />
            <PrivateRoute exact path="/record" component = {Record} />
            <PrivateRoute exact path="/viewallcandidates" component = {ViewAllCandidates} />
          {  AuthService.isAdmin() ? (
            <>
              <PrivateRoute exact path="/" component = {Admin} />
              <PrivateRoute exact path="/mock" component = {MockUser} data = {{ setMock: setMock, studentInfo:studentInfo, votes:votes, setVotes:setVotes, setStudentInfo:setStudentInfo, setBallotData:setBallotData, electionData: electionData}} />
              <PrivateRoute exact path="/election" component = {ManageElection} data = {{ electionData: electionData, setElectionData: setElectionData, handlePost:handlePost  }}/>
              <PrivateRoute exact path="/candidate" component = {ManageCandidate} />
              <PrivateRoute exact path="/party" component = {ManageParty} data = {{ electionData: electionData}}/>
              <PrivateRoute exact path="/admin" component = {ManageAdmin} />
              <PrivateRoute exact path="/results" component = {ManageResults} />
              <PrivateRoute exact path="/editelection" component = {EditElection} data = {{ electionData: electionData, ballotData:ballotData, setBallotData:setBallotData}}/>
            </>
          ) : '' }

          { AuthService.isStudent() && !AuthService.isAdmin() ? (
            <>
            <PrivateRoute exact path="/" component = {Vote} data = {{ isLoading:isLoading, studentInfo:studentInfo, votes:votes, ballotData:ballotData, setVotes:setVotes, setStudentInfo:setStudentInfo, setBallotData:setBallotData}} />
            </>
          ) : <PrivateRoute exact path="/vote" component = {Vote} data = {{ isLoading:isLoading, studentInfo:studentInfo, votes:votes, ballotData:ballotData, setVotes:setVotes, setStudentInfo:setStudentInfo, setBallotData:setBallotData}} />}
          { AuthService.isCandidate() ? (
            <>
            <PrivateRoute exact  path = "/statement" component = {Statement}/>
            <PrivateRoute exact  path = "/viewstatement" component = {ViewStatement}/>
            <PrivateRoute exact  path = "/viewcandidate" component = {ViewCandidate}/>
            </>
          ) : ''}
          { !AuthService.isAdmin() && !AuthService.isStudent() && !AuthService.isCandidate() ? (
            <PrivateRoute exact path="/" component = {Home} />
          ) : ''}
          <PrivateRoute
              path='/candidate/:id'
              component={CandidateProfile}
            />
        </div>
      </div>
      <PageFooter />
      </Router>
    </>
  );
}

